import React, { useEffect, useRef } from 'react';

const ContextMenu = ({ x, y, items, onClose, visible }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [visible, onClose]);

  if (!visible || !items || items.length === 0) {
    return null;
  }

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{
        position: 'fixed',
        left: x,
        top: y,
        background: 'var(--panel)',
        border: '1px solid var(--border)',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        zIndex: 1000,
        minWidth: '180px',
        padding: '4px 0',
        backdropFilter: 'blur(8px)'
      }}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="context-menu-item"
          onClick={() => {
            if (item.action) {
              item.action();
            }
            onClose();
          }}
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            color: item.disabled ? 'var(--muted)' : 'var(--text)',
            cursor: item.disabled ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.2s ease',
            opacity: item.disabled ? 0.5 : 1,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={(e) => {
            if (!item.disabled) {
              e.currentTarget.style.backgroundColor = 'var(--accent)';
              e.currentTarget.style.color = 'white';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = item.disabled ? 'var(--muted)' : 'var(--text)';
          }}
        >
          {item.icon && <span style={{ fontSize: '16px' }}>{item.icon}</span>}
          <span>{item.label}</span>
          {item.shortcut && (
            <span style={{ 
              marginLeft: 'auto', 
              fontSize: '12px', 
              color: 'var(--muted)',
              fontFamily: 'monospace'
            }}>
              {item.shortcut}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContextMenu;
